<div class="card sm-12 hide-on-print">
  <div class="card-header btn-main-color">{{ 'PATIENT' | translate}}:
    {{appointmentSlot.patient?.name}} {{appointmentSlot.patient?.lastname}}</div>
  <div class="card-body">

    <h5 class="card-title">{{ 'DEPARTMENT' | translate}}:
      {{appointmentSlot.department?.name |
                  translate}}</h5>
    <p class="card-text">{{ 'DATE' | translate}}:
      {{appointmentSlot.date | date: 'dd/MM/yyyy' }} |
      {{ 'HOUR' | translate}}: {{appointmentSlot.hour | slice:0:5 }}</p>
  </div>
</div>